import { render, staticRenderFns } from "./SetupOverviewGroupSync.vue?vue&type=template&id=c162b856&scoped=true"
import script from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewGroupSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c162b856",
  null
  
)

export default component.exports